<div class="wrapper">
    <app-header></app-header>
    <section class="content">
        <app-navmenu></app-navmenu>
        <main id="content" class="panel" tabindex="-1">
            <router-outlet></router-outlet>
        </main>
    </section>
</div>